import request from './common/request'

import { MERCHANT_HELP_CONFIG_URI } from './urls'

async function allHelpConfigs (params) {
  return request(
    {
      url: `${MERCHANT_HELP_CONFIG_URI}/all`,
      method: 'GET',
      params
    }
  )
}

export default {
  allHelpConfigs
}



// WEBPACK FOOTER //
// ./src/api/merchant-help.js